import { render, staticRenderFns } from "./text-styles.vue?vue&type=template&id=26f61b9e&"
import script from "./text-styles.vue?vue&type=script&lang=js&"
export * from "./text-styles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports